module.exports = __webpack_public_path__ + "static/img/winter_luoboPic.afbf53c1.png";